import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/Logger.requests'
import {
    LoggerResponse,
} from '../Loggers.types'

const useGetLoggerByLoggerNumber = (
    loggerNumber: string,
) => {
    return useRequest<LoggerResponse>({
        key: RequestKeys.getLoggerByLoggerNumber,
        params: {
            loggerNumber,
        },
        requestFunc: RequestFn.getEntity(config.getByLoggerNumber),
        enabled: Boolean(loggerNumber),
        keepPreviousData: false,
    })
}

export default useGetLoggerByLoggerNumber
